module.exports = __webpack_public_path__ + "static/media/historyBackground.e79b5e17.jpg";